import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {UsersService} from '../../users/service/users.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {TransformationModel} from '../../../models/TransformationModel';
import {TransformationService} from './service-transformation/transformation.service';

@Component({
  selector: 'app-transformation',
  templateUrl: './transformation.component.html',
  styleUrls: ['./transformation.component.scss']
})
export class TransformationComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isTransformationSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: TransformationModel;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private transformationService: TransformationService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new TransformationModel();
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isTransformationSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    if (this.showActions === true) {
      this.displayedColumns = ['contractTypeDesc', 'localCustomerDesc', 'serviceVariantCod', 'currencyDesc',
        'chargingMethodology', 'milestoneNumber', 'amount', 'perInstallment', 'totalCost', 'region',
        'region1', 'perCostRegion1', 'region2', 'perCostRegion2', 'actions'];
    } else {
      this.displayedColumns = ['contractTypeDesc', 'localCustomerDesc', 'serviceVariantCod', 'currencyDesc',
        'chargingMethodology', 'milestoneNumber', 'amount', 'perInstallment', 'totalCost', 'region',
        'region1', 'perCostRegion1', 'region2', 'perCostRegion2'];
    }

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.TRANSFORMATION_OFFSET);
    this.getSessionStorageFilter();
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  init() {
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    if (!this.reportSection) {
      this.showFilter = false;
      this.getDataPage(this.offset, this.filter);
    } else {
      this.showFilter = true;
    }
    this.loaderService.display(false);

  }


  getDataPage(offset: Offset, filter: TransformationModel) {
    this.getPageSubscribe = this.transformationService.getPage(offset, filter)
      .subscribe(
        (rFinal: any) => {
          this.dataSource = rFinal.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = rFinal.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const TransformationData = this.dataSource.find(data => data.id === id) as TransformationModel, list: GenericArray[] = [
        {id: 'Provider Cod', value: this.toCustomString(TransformationData.provider.cod)},
        {id: 'Provider Description', value: this.toCustomString(TransformationData.provider.description)},
        {id: 'Contract Type Description', value: this.toCustomString(TransformationData.contractType.description)},
        {id: 'Contract Type Cod', value: this.toCustomString(TransformationData.contractType.cod)},
        {id: 'Local Customer Description', value: this.toCustomString(TransformationData.localCustomer.description)},
        {id: 'Local Customer Cod', value: this.toCustomString(TransformationData.localCustomer.cod)},
        {id: 'Service Variant Description', value: this.toCustomString(TransformationData.serviceVariant.description)},
        {id: 'Service Variant Cod', value: this.toCustomString(TransformationData.serviceVariant.cod)},
        {id: 'Currency Cod', value: this.toCustomString(TransformationData.currency.cod)},
        {id: 'Currency Description', value: this.toCustomString(TransformationData.currency.description)},
        {id: 'Charging Methodology', value: this.toCustomString(TransformationData.chargingMethodology)},
        {id: 'Milestone Number', value: this.toCustomString(TransformationData.milestoneNumber)},
        {id: 'Amount', value: this.toCustomString(TransformationData.amount)},
        {id: 'Installment', value: this.toCustomStringNumberPerc(TransformationData.perInstallment)},
        {id: 'Total Cost', value: this.toCustomString(TransformationData.totalCost)},
        {id: 'Shared Region Description', value: this.toCustomString(TransformationData.region.description)},
        {id: 'Shared Region Cod', value: this.toCustomString(TransformationData.region.cod)},
        {id: 'Region 1 Description', value: this.toCustomString(TransformationData.region1 ? TransformationData.region1.description : 'N.D.')},
        {id: 'Region 1 Cod', value: this.toCustomString(TransformationData.region1 ? TransformationData.region1.cod : 'N.D.')},
        {id: 'Region 1 Description', value: this.toCustomString(TransformationData.region1 ? TransformationData.region2.description : 'N.D.')},
        {id: 'Cost Region 1', value: this.toCustomStringNumberPerc(TransformationData.perCostRegion1)},
        {id: 'Region 2 Cod', value: this.toCustomString(TransformationData.region2 ? TransformationData.region2.cod : 'N.D.')},
        {id: 'Region 2 Description', value: this.toCustomString(TransformationData.region2 ? TransformationData.region2.description : 'N.D.')},
        {id: 'Cost Region 2', value: this.toCustomStringNumberPerc(TransformationData.perCostRegion2)}
      ],
      dialogRef = this.dialog.open(DialogDetailComponent, {
        width: '40%',
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.TRANSFORMATION_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }


  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  showNewMassive() {
    let showNewMassive = false;
    if (this.canInsert) {
      showNewMassive = true;
    }
    if (this.reportSection) {
      showNewMassive = false;
    }
    return showNewMassive;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.TRANSFORMATION_FILTER));
    this.filter = filter_ ? filter_ : new TransformationModel();
  }
}

